import { render } from "./ChildrenBenefit.vue?vue&type=template&id=3b0ecd4c&scoped=true"
import script from "./ChildrenBenefit.vue?vue&type=script&lang=js"
export * from "./ChildrenBenefit.vue?vue&type=script&lang=js"

import "./ChildrenBenefit.vue?vue&type=style&index=0&id=3b0ecd4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b0ecd4c"]])

export default __exports__